"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNameFromFilename = exports.getFileType = exports.getExtensionFromFilename = void 0;
var _utils = require("@thinkvn/utils");
var _mimeType = require("./mime-type");
const getExtensionFromFilename = name => name.split(".").pop();
exports.getExtensionFromFilename = getExtensionFromFilename;
const getNameFromFilename = name => name.split(".").slice(0, -1).join("-");
exports.getNameFromFilename = getNameFromFilename;
const getFileType = file => {
  if ((0, _utils.isString)(file)) {
    const extension = getExtensionFromFilename(file);
    return extension ? (0, _mimeType.guesstimateMimeType)(extension) : "";
  } else {
    return file.type;
  }
};
exports.getFileType = getFileType;